"use client";

import { domAnimation, LazyMotion } from "motion/react";
import { ReactNode } from "react";

export function MotionProvider({ children }: { children: ReactNode }) {
  return <LazyMotion features={domAnimation}>{children}</LazyMotion>;
}
